export const checksums = {
  "content": "v3.5.0--s5SCOFZZBjyMe7sB2w4R-7zaRbQJz2uTgx3mjmc9B0U",
  "contentJson": "v3.5.0--Sbq9IzdP7XZXHz_hO0fgYrrnfEuwbvWGvR8crpruGE4"
}
export const checksumsStructure = {
  "content": "7YGg8fu3bOxrcYysg4skMqpQEwP1h5mBTy2bp9FEYmk",
  "contentJson": "stUoatUPs0AelDGJKVBgxr6qRuk2UELBDQA4_N5RSfA"
}

export const tables = {
  "content": "_content_content",
  "contentJson": "_content_contentJson",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "updatedAt": "string",
      "createddAt": "string",
      "type": "string"
    }
  },
  "contentJson": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "items": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}